<template>
  <div class="container">
    <div class="entity-header">

      <div class="entity-title">Management</div>

      <transition name="modal-fade" v-if="showImportingPlayerStatus">
        <div class="modal-backdrop">
          <div class="modal">
            <section class="modal-body">
              <slot name="body">
                <div class="importStatus">
                  <header>
                    <h4>{{ $t('management.playerImport') }}</h4>
                  </header> 
                  <div class="content">
                    <label>
                      {{ $t('management.importStatus') }}
                    </label>
                    <div class="w3-panel errorBox w3-round" style="white-space: pre-line;">
                      {{ currentPlayerImportStatus }}
                      <font-awesome-icon icon="cog" class="fa-spinner fa-spin icon" />
                    </div>
                  </div>
                </div>
              </slot>
            </section>
          </div>
        </div>
      </transition>
<!-- 
    <div class="bar">
        <a href="#" @Click="setTab('statistics')" class="bar-item">statistieken</a>
        <a href="#" @Click="setTab('data')" class="bar-item">stamdata</a>
        <a href="#" @Click="setTab('maintenance')" class="bar-item">beheer</a>
    </div>
-->
      <div class="tab-nav">
        <div @click.prevent="setActiveTab('statistics')" class="tab" :class="{ active: isActiveTab('statistics') }">statistieken</div> 
        <div @click.prevent="setActiveTab('data')" class="tab" :class="{ active: isActiveTab('data') }">stamdata</div> 
        <div @click.prevent="setActiveTab('maintenance')" class="tab" :class="{ active: isActiveTab('maintenance') }">beheer</div> 
      </div>
    </div>


    <div class="statistics" v-if="isActiveTab('statistics')">
      <h4 class="groupheader">statistics</h4>
      <h5>Nr of players</h5>
      <h5>Nr of tournaments (started, running, finished)</h5>
      <h5>etc. ?</h5>
    </div> 

    <div class="data" v-if="isActiveTab('data')">
      <h2>Import KNSB rating lists</h2>
      <select class="theme-input" v-model="ratingListSelected">
        <option class="placeholder" value="-1" disabled selected hidden>selecteer een KNSB ratinglijst</option>
        <option v-for="ratinglist in ratingListsStillAvailable" v-bind:key="ratinglist.listId" :value="ratinglist.listId">{{ratinglist.year}} {{ratinglist.month}} {{(ratinglist.category)}}</option>
      </select>

      <div v-if="ratingListsDone.length <= 0" class="spincontainer">
        <font-awesome-icon icon="cog" class="fa-spinner fa-spin icon" /> loading knsb lists...  
      </div>
      <br v-if="ratingListsDone.length > 0"/>
      <button class="button-default" href="#" @click="updatePlayers">import playerdata</button>
      <div v-if="importPlayerEndStatus != ''"> {{ importPlayerEndStatus }}</div>
      <br/>
<!--      
      <h2>Import by zip URL</h2>
        <label>
          {{ $t('tournament.location') }}
          <input v-model="ratingListURL" class="theme-input" type="text" :placeholder="'Vul hier de ZIP url in'">
        </label>
      <br/>
      <a href="#" @click="updatePlayersByZip">update Schaakbond playerdata by ZIP URL</a>
      <div v-if="isPlayersUpdating" class="spincontainer">
        <font-awesome-icon icon="cog" class="fa-spinner fa-spin icon" /> Updating...
      </div>      
-->
      <div v-if="playersUpdated">Players updated.</div>
      <div v-if="ratingListsDone.length > 0">
        <h2>Verwerkte ratinglijsten</h2>
        <div v-for="ratinglist in ratingListsDone" v-bind:key="ratinglist.ratingListId"> {{ratinglist.year}} {{ratinglist.month}}</div>
      </div>
    </div>

    <div class="data" v-if="isActiveTab('maintenance')">
      <h4 class="groupheader">tournament maintenance</h4>
        <div v-if="isLoading" class="spincontainer">
          <font-awesome-icon icon="cog" class="fa-spinner fa-spin icon" /> loading...
        </div>      
        <mgt-tournaments-list :tournaments="tournaments" v-on:tournamentListChanged="tournamentListChanged"></mgt-tournaments-list>
      <h4 class="groupheader">user maintenance</h4>
    </div>
  </div>

</template>

<script>

import {user} from "@/components/users";
import MgtTournamentsList from "@/components/management/TournamentsList";
import {RestAPI} from "@aws-amplify/api-rest";

const apiName = 'api';
const myInit = { 
  response: false, 
};

export default {
  name: 'Dashboard',
  components: {MgtTournamentsList},
  computed: {
    isLoading() {
      return this.loading;
    },
    playersUpdated() {
      return this.playersUpdateReady;
    },
    isPlayersUpdating() {
      return this.playersUpdating;
    },
    loggedIn: function () {
      return user.loggedIn;
    },   
    showImportingPlayerStatus() {
      return this.showingImportingPlayerStatus;
    }
  },
  data: function() {
    return {
      activeTabItem: 'data',
      currentPlayerImportStatus: "",
      importPlayerEndStatus: "",
      interval: null,
      loading: true,
      playersUpdateReady: false,
      playersUpdating: false,
      ratingListsDone: [],
      ratingListSelected: -1,
      ratingListURL: "",
      ratingListsStillAvailable: [],
      searchString: "",
      showingImportingPlayerStatus: false,
      tournaments: []
    }
  },
  beforeMount() {
    this.loadTournaments();
    this.loadAvailableRatinglists();
  },
  updated: function () {
    this.$nextTick(function () {
      this.loading=false;
    })
  },
  methods: {
    getImportStatus() {
      if (this.playersUpdating) {
        let completePath = "/management/importStatus?listId=" + this.ratingListSelected;
        let that = this
        const authlInit = { 
          headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
          response: true,
        };
        RestAPI
          .get(apiName, completePath, authlInit)
          .then(response => {
            that.currentPlayerImportStatus = response.data.message;
            console.log(JSON.stringify(response));
          })
          .catch(error => {
              if (error.status !== 404) {
              console.log("ERROR", JSON.stringify(error));
            }
          });
      } 
    },

    isActiveTab (tabItem) {
      return this.activeTabItem === tabItem;
    },

    l(text) {
      return this.$t('dashboard.' + text)
    },

    loadAvailableRatinglists() {
      let that = this;
      const listPath = '/ratinglist';
      RestAPI
        .get(apiName, listPath, myInit)
        .then(response => {
          var AllRatingLists = response;
          console.log(JSON.stringify(AllRatingLists));
          that.ratingListsStillAvailable = AllRatingLists.filter((item) => {
            return (item.processed == false);
          });
          that.ratingListsDone = AllRatingLists.filter((item) => {
            return (item.processed == true);
          });
          that.compactRatingLists();
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    loadTournaments() {
      let that = this;
      const listPath = '/tournament';
      RestAPI
        .get(apiName, listPath, myInit)
        .then(response => {
          that.tournaments = response;
          console.log(JSON.stringify(that.tournaments));
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    setActiveTab(newTab) {
      this.activeTabItem = newTab;
    },

    compactRatingLists() {
      console.log(this.ratingListsDone);

      // 1. Group per year
      const groups = this.ratingListsDone.reduce((acc, item) => {
        if (!acc[item.year]) acc[item.year] = [];
        acc[item.year].push(item);
        return acc;
      }, {});

      const newArray = [];

      // 2. Loop through the years
      for (const year in groups) {
        const items = groups[year];
        
        // check availabilty of all 12 months
        if (items.length === 12) {
          // Then keep one and adjust the text
          const fullYearEntry = { ...items[0], month: " (volledig)" };
          newArray.push(fullYearEntry);
        } else {
          // Otherwise, add single months
          newArray.push(...items);
        }
      }

      // 3. Update the original array
      this.ratingListsDone = newArray;
    },

    tournamentListChanged() {
      this.loadTournaments();
    },

    updatePlayers() {
      const AuthInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        response: true, 
      };
      this.showingImportingPlayerStatus = true;
      let that = this
      this.playersUpdating = true;
      let fullPath = "/management/playerupdate?listId=" + this.ratingListSelected;
      console.log("updating players");
      this.interval = setInterval(() => {
        this.getImportStatus();
      }, 3000); // every 3 seconds
      RestAPI
        .get(apiName, fullPath, AuthInit)
        .then(response => {
          that.playersUpdating = false;
          that.playersUpdateReady = true;
          that.showingImportingPlayerStatus = false;
          clearInterval(this.interval); 
          console.log("Updated players" + JSON.stringify(response));
          this.importPlayerEndStatus = "List " + this.ratingListSelected +  "imported succesfully";
        })
        .catch(error => {
          that.playersUpdating = false;
          console.log(error.response);
          that.showingImportingPlayerStatus = false;
          clearInterval(this.interval); 
        });
      },
    
    updatePlayersByZip() {
      const AuthInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        response: true, 
      };
      this.showingImportingPlayerStatus = true;
      let that = this
      this.playersUpdating = true;
      let fullPath = "/management/playerupdatebyzipurl?url=" + encodeURIComponent(this.ratingListURL);
      console.log("updating players");
      this.interval = setInterval(() => {
        this.getImportStatus();
      }, 10000); // every 10 seconds
      RestAPI
        .get(apiName, fullPath, AuthInit)
        .then(response => {
          that.playersUpdating = false;
          that.playersUpdateReady = true;
          that.showingImportingPlayerStatus = false;
          clearInterval(this.interval); 
          console.log("Updated players" + JSON.stringify(response));
        })
        .catch(error => {
          that.playersUpdating = false;
          console.log(error.response);
          that.showingImportingPlayerStatus = false;
          clearInterval(this.interval); 
        });
      }
    }
}
</script>

<style scoped>

.container {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  padding: 1vw;
  box-sizing: border-box;
}

h1 {
  text-align: center;
}
.logoContainer {
  position: relative;
  width: 100%;
}
.smaller {
  font-size: 12px;
}
.infoLink h6:hover {
  color: #ff2626;
  transition: color .25s linear;
}

.fa-spin {
  float: right;
  margin-top: 4px;
  padding-top: 4px;
}

/* mobile */
@media screen and (max-width: 600px) {
  h1 {
    font-size: 32px;
  }

  .container {
    width: 98vw;
    padding: 2vw;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .container {
    width: 90vw;
    max-width: 800px;
  }

  .actionPanel {
    max-width: 50VW;
  }

}

/* laptop */
@media screen and (min-width: 1281px) {
  .container {
    width: 50vw;
    max-width: 1000px;
  }

  .actionPanel {
    max-width: 25VW;
  }

}

</style>
